import React from 'react';

import ReusableList from '../../../../../../reusables/List';
import ReusableTitle from '../../../../../../reusables/Title';

interface IProps {
  items?: any[];
  title: string;
}

const CardSummary = ({ items, title }: IProps) => (
  <>
    <ReusableTitle
      fontSize="12px"
      fontWeight="400"
      lineHeight="16px"
      title={title}
    />
    {items && <ReusableList items={items} style={{ marginTop: '4px' }} />}
  </>
);

export default CardSummary;
